var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7808 24.7241C19.3772 24.7241 24.7247 19.3766 24.7247 12.7802C24.7247 6.18376 19.3772 0.836304 12.7808 0.836304C6.18437 0.836304 0.836914 6.18376 0.836914 12.7802C0.836914 19.3766 6.18437 24.7241 12.7808 24.7241Z",
    stroke: "white",
    strokeWidth: 1.67278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1816 11.5029H14.38V19.1597C14.38 20.0423 13.6634 20.7589 12.7808 20.7589C11.8982 20.7589 11.1816 20.0423 11.1816 19.1597V11.5029V11.5029Z",
    stroke: "white",
    strokeWidth: 1.67278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.781 8.90898C13.9328 8.90898 14.8666 7.9752 14.8666 6.82333C14.8666 5.67145 13.9328 4.73767 12.781 4.73767C11.6291 4.73767 10.6953 5.67145 10.6953 6.82333C10.6953 7.9752 11.6291 8.90898 12.781 8.90898Z",
    stroke: "white",
    strokeWidth: 1.67278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.d3f513169f30e1293d3567416e75e103.svg";
export { ForwardRef as ReactComponent };